<div>
	<slot />
</div>

